import { useEffect, useState } from "react";
import { api } from "../api";
import { PageHeader, Table, Badge, eur } from "../components/common";

export function Commissions() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/commissions").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const cols = [
    { key: "comercial_id", label: "Comercial" },
    { key: "base", label: "Base", render: (r) => eur(r.base) },
    { key: "taxa", label: "Taxa", render: (r) => `${r.taxa} %` },
    { key: "tipo", label: "Tipo" },
    { key: "estado", label: "Estado", render: (r) => <Badge value={r.estado} /> },
  ];
  return (
    <div>
      <PageHeader overline="Comercial" title="Comissoes" />
      <p className="text-muted2 text-sm mb-6">Comissoes calculadas por comercial. Sem registos ate existirem encomendas atribuidas.</p>
      <Table columns={cols} rows={rows} testid="commissions-table" />
    </div>
  );
}

export function Discounts() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/discounts").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const cols = [
    { key: "ambito", label: "Ambito", render: (r) => <Badge value={r.ambito} /> },
    { key: "valor_percent", label: "Valor", render: (r) => `${r.valor_percent} %` },
    { key: "motivo", label: "Motivo" },
    { key: "proposto_por", label: "Proposto por" },
    { key: "aprovado_por", label: "Aprovado por", render: (r) => r.aprovado_por || "-" },
    { key: "estado", label: "Estado", render: (r) => <Badge value={r.estado} /> },
  ];
  return (
    <div>
      <PageHeader overline="Pricing" title="Precos e descontos" />
      <p className="text-muted2 text-sm mb-6 max-w-2xl leading-relaxed">
        Descontos aplicados em encomendas online e vendas assistidas. Descontos ad-hoc requerem aprovacao da gestao.
      </p>
      <Table columns={cols} rows={rows} testid="discounts-table" />
    </div>
  );
}
